import { ZYIcon } from './iconfont';
import { Modal, message } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';

export function updateStatus() {
  if (navigator.onLine) {
    // alert('联机');
    message.destroy('key_error');
  } else {
    message.open({
      content: (
        <span>
          网络连接已断开，请检查您的网络连接
          <span
            onClick={() => message.destroy('key_error')}
            style={{ cursor: 'pointer', marginLeft: 10 }}
          >
            <ZYIcon type="guanbi" />
          </span>
        </span>
      ),
      type: 'warning',
      duration: 0,
      key: 'key_error',
    });
  }
}

export function onRefresh() {
  Modal.warning({
    title: '登录账号变更',
    content: '当前登录账号已变更，请刷新页面获取最新内容',
    icon: <ExclamationCircleFilled />,
    onOk() {
      window.location.reload();
    },
    okText: '刷新',
  });
}
